<ppl-dialog title="Space Access Forbidden"
            i18n-title="@@Space_Access_Forbidden"
            [actionVisible]="false"
            cancelLabel="close"
            width="400px">
  <div class="container">
    <div>
      <div class="icon">
        <ppl-icon svgIcon="logo-coevera"
                  width="96px"
                  height="96px"></ppl-icon>
        <ppl-icon class="icon-logout"
                  svgIcon="logout-restriction"
                  width="35px"
                  height="35px"></ppl-icon>
      </div>
    </div>
    <div class="title"
         i18n="@@Access_Restricted">Access Restricted</div>
    <div>{{ message }}</div>
  </div>
</ppl-dialog>
